module.exports = global["jQuery"] = require("-!/builds/Spartans/steigtechnik/node_modules/expose-loader/index.js?$!./jquery.js");